// lib/gtag.ts

// Track a page view
export const pageview = (url) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_path: url,
    });
  }
};

// Track a specific event (e.g. purchase, signup, etc.)
export const event = (action, params) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', action, params);
  }
};
